import { useEffect, useState, useCallback } from 'react';

import EmpresaService from '@services/EmpresaService';

const useEmpresas = () => {
    const [ data, setData ] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState(null);

    const fetchData = useCallback(() => {
        setLoading(true);
        
        EmpresaService.listar()
            .then(res => setData(res.data.map(e => ({ value: e.id, label: e.nome }) )))
            .catch(err => setError(err))
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => fetchData(), [fetchData]);

    return { data, loading, error };
}

export default useEmpresas;